import * as React from 'react';
import ParentBlock from './parent_block/template';
import { ContentBlockEditorData } from './types';

export default class ContentBlockEditor extends React.Component<ContentBlockEditorData> {
  render() {
    return <ParentBlock {...this.props} />;
  }
}
